import Grid from '@mui/material/Unstable_Grid2';
import React from 'react';
import Typography from '@mui/material/Typography';

interface MessageBoxProps {
  header: string;
  message: string;
  additionalMessage?: string; // use this when separate line is required.
  secondaryHeader?: string;
  secondaryMessage?: string | JSX.Element;
}

const MessageBox = (props: MessageBoxProps) => (
  <Grid container justifyContent="center" direction="column" spacing={2}>
    <Grid>
      <Typography variant="h5" color="primary" align="center">
        {props.header}
      </Typography>
    </Grid>
    <Grid>
      <Typography align="center" style={{ fontSize: '1rem !important' }}>
        {props.message}
      </Typography>
      <Typography variant="body1" style={{ fontWeight: 'bold' }} align="center">
        {props.additionalMessage}
      </Typography>
    </Grid>
    <Grid>
      <Typography
        className="smaller-font"
        style={{ fontWeight: 'bold', color: '#222222' }}
        variant="body2"
        align="center"
      >
        {props.secondaryHeader}
      </Typography>
      {typeof props.secondaryMessage === 'string' ? (
        <Typography className="smaller-font" align="center">
          {props.secondaryMessage}
        </Typography>
      ) : (
        <div className="smaller-font centered">{props.secondaryMessage}</div>
      )}
    </Grid>
  </Grid>
);

export default MessageBox;
